import React from 'react';
import './contactinfosection3.css'
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function Contactinfosection3() {
  return (
    <>
    <div className="icon-focused-container">
      {/* Contact Details Section */}
      <div className="contact-details">
        <div className="contact-item">
          <div className="icon-wrapper">
            <i className="fas fa-map-marker-alt"></i>
          </div>
          <div className="text-wrapper">
            <h4>Address</h4>
            <p>Plot No:9N16,4th Floor,Cowork venue,Arch Bishop's House, Satyanagar,Bhubaneswar,751007,Odisha,India</p>
          </div>
        </div>

        <div className="contact-item">
          <div className="icon-wrapper">
            <i className="fas fa-phone"></i>
          </div>
          <div className="text-wrapper">
            <h4>Phone</h4>
            <p>+91 9776522386</p>
          </div>
        </div>

        <div className="contact-item">
          <div className="icon-wrapper">
            <i className="fas fa-envelope"></i>
          </div>
          <div className="text-wrapper">
            <h4>Email</h4>
             <p>sarsindialiaison@gmail.com</p>
             <br/>
            <p>contact@sarsindialiaison.com</p>
          </div>
        </div>
      </div>

      {/* Social Media Section */}
      <div className="social-media-section">
        <a href="/contact-us" className="social-icon">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="/contact-us" className="social-icon">
          <i className="fab fa-twitter"></i>
        </a>
        <a href="/contact-us" className="social-icon">
          <i className="fab fa-linkedin-in"></i>
        </a>
        <a href="/contact-us" className="social-icon">
          <i className="fab fa-instagram"></i>
        </a>
      </div>

      {/* Map Section */}
      <div className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.470072494524!2d85.84291227398616!3d20.280801013050006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190a2400000001%3A0x15c2084ee9ff130c!2sSARS%20INDIA%20LIAISON%20PVT.%20LTD!5e0!3m2!1sen!2sin!4v1769397176755!5m2!1sen!2sin" 
          className="map-iframe"
          allowFullScreen=""
          loading="lazy"
          title="Office Location"
        ></iframe>
      </div>
    </div>
    
    
    
    
    </>
  )
}
